var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';

var Tabs = function (_React$PureComponent) {
  _inherits(Tabs, _React$PureComponent);

  function Tabs() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Tabs);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.setInkBarPosition = function () {
      var index = Array.prototype.slice.call(_this.tabRoot.children).filter(function (element) {
        return !element.classList.contains('mdc-Tabs-InkBar');
      }).findIndex(function (tab) {
        return tab.firstElementChild.classList.contains('active');
      });
      _this.inkbarNode.classList.remove('transition-right', 'transition-left');
      if (index === -1) {
        _this.inkbarNode.style.display = 'none';
      } else {
        _this.inkbarNode.style.display = ''; // semantically this means 'initial'. but this does not work in ie10 / ie11
        var width = 100 / _this.props.tabs.length;
        var prevIndex = _this.inkbarNode.style.left ? Math.round(parseFloat(_this.inkbarNode.style.left) / width) : -1;
        var direction = index > prevIndex ? 'right' : 'left';
        var left = index * width;
        var right = (_this.props.tabs.length - index - 1) * width;
        _this.inkbarNode.style.left = left + '%';
        _this.inkbarNode.style.right = right + '%';
        if (prevIndex !== -1) {
          _this.inkbarNode.classList.add('transition-' + direction);
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Tabs, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setInkBarPosition();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      // move inkbar AFTER nav/link children have been updated and reflect
      // "activeClassName" (active). This cannot be done before.
      this.setInkBarPosition();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return React.createElement(
        'div',
        { className: 'mdc-Tabs', ref: function ref(node) {
            _this2.tabRoot = node;
          } },
        this.props.tabs.map(function (tab, index) {
          return React.createElement(
            'div',
            { key: index, className: 'mdc-Tabs-Item' },
            tab
          );
        }),
        React.createElement('div', {
          ref: function ref(node) {
            _this2.inkbarNode = node;
          },
          className: 'mdc-Tabs-InkBar'
        })
      );
    }
  }]);

  return Tabs;
}(React.PureComponent);

Tabs.propTypes = {
  tabs: PropTypes.array
};
Tabs.defaultProps = {
  tabs: []
};


export default Tabs;


//////////////////
// WEBPACK FOOTER
// ../es/js/tabs/index.js
// module id = 312
// module chunks = 0